module.exports = "https://cdn.realtymogul.com/static/media/RP_Englishvillage.d2bb3233.jpg";